import { NotificationStatuses } from './../../create-notification/create-notification/create-notification.component';
import { Component, inject, Input, OnInit } from '@angular/core';
import { NotificationClient } from 'src/app/client/notification.client';
import { NotificationInstance } from 'src/app/common/entity/notification/notification.model';

@Component({
  selector: 'app-user-notifications-overview',
  templateUrl: './user-notifications-overview.component.html',
  styleUrls: ['./user-notifications-overview.component.css']
})
export class UserNotificationsOverviewComponent implements OnInit {

  public NotificationStatuses = NotificationStatuses;
  public notificationClient = inject(NotificationClient);
  @Input() userNotifications: NotificationInstance[];
  constructor() { }


  getValue(notification: NotificationInstance, code: string): string {
    return notification?.Fields?.find(c => c.Code === code)?.Value ?? '';
  }

  ngOnInit(): void {
  }

  setExpireNotificationVisible(notificationStatus: number): boolean {
    return notificationStatus <= NotificationStatuses.Published;
  }

  setDeleteNotificationVisible(notificationStatus: number): boolean {
    return notificationStatus <= NotificationStatuses.Expired;
  }

  setPublishNotificationVisible(notificationStatus: number): boolean {
    return notificationStatus <= NotificationStatuses.Draft;
  }

  changeNotificationStatus(notification: NotificationInstance, notificationStatusId: NotificationStatuses) {
    this.notificationClient
      .changeNotificationStatus(notification.PK_ID!, notificationStatusId)
      .then((response) => {
        switch (notificationStatusId){
          case NotificationStatuses.Publishing:
            var notificationToUpdate = this.userNotifications.find(n => n.PK_ID === notification.PK_ID);
            notificationToUpdate.NotificationStatusId = NotificationStatuses.Published,
            notificationToUpdate.NotificationStatusDescription = 'Published';
            break;
          case NotificationStatuses.Expired:
            var notificationToUpdate = this.userNotifications.find(n => n.PK_ID === notification.PK_ID);
            notificationToUpdate.NotificationStatusId = NotificationStatuses.Expired,
            notificationToUpdate.NotificationStatusDescription = 'Expired';
            break;
          case NotificationStatuses.Deleted:
            this.userNotifications = this.userNotifications.filter(n => n.PK_ID !== notification.PK_ID);
            break;
        }
      });
  }
}
